import PropTypes from 'prop-types';

import HelpersController from './../HelpersController';

let _this = {};

/**
 *
 */
class LayersDifferentials extends HelpersController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);

        this.props = props;
        this.main = main;

        _this = this;
    };

    /**
     *
     * @returns {*}
     */
    get = () => {
        const {current_name} = this.props;

        return this.main.getState(`_this_${current_name}`);
    };

    /**
     *
     * @returns {string}
     */
    occurrence = () => {
        const {currentFrame} = this.get();

        return this.padWithLeadingZeros(currentFrame, 2);
    };

    /**
     *
     * @param frame
     * @param visible
     */
    navigate = (frame, visible = false) => {
        const {occ_differentials, occ_icon_differentials} = this.get();

        occ_differentials.gotoAndStop(frame);
        occ_icon_differentials.occ_more.visible = !visible;
        occ_icon_differentials.occ_less.visible = visible;
        visible && this.main.effectFadeIn(occ_differentials, `occ_frame_${this.occurrence()}`);
    };

    /**
     *
     */
    close = () => {
        const {default_frame} = this.props;

        this.navigate(default_frame);
    };

    /**
     *
     */
    show = () => {
        const {occ_icon_differentials} = this.get();

        occ_icon_differentials.occ_more.isVisible() ? this.navigate(`frame${this.occurrence()}`, true) : this.close();
    };

    /**
     *
     */
    create = () => {
        const
            {name} = this.props,
            {btn_differentials} = this.get();

        this.close();

        this.removeListener('click', `show-${name}`, this.show, () => {
            this.addListener(btn_differentials, 'click', `show-${name}`, this.show);
        });
    };
}

/**
 *
 * @type {{default_frame: Requireable<string>, name: Requireable<string>, current_name: Requireable<string>}}
 */
const propTypes = {
    name: PropTypes.string,
    default_frame: PropTypes.string,
    current_name: PropTypes.string
};

/**
 *
 * @type {{default: {default_frame: string, name: string, current_name: null}}}
 */
const config = {
    default: {
        name: 'differentials',
        default_frame: 'frame00',
        current_name: null
    }
};

/**
 *
 * @param _this
 * @returns {function(*): LayersDifferentials}
 */
export default (_this) => (props) => {
    const defaultProps = {...config.default, ...props};
    PropTypes.checkPropTypes(propTypes, defaultProps, 'prop', 'LayersDifferentials');
    return (new LayersDifferentials(defaultProps, _this));
};